import React, { memo, useEffect, useState } from "react";
import Modal from "styled-react-modal";
import LottieLoader from "./LottieLoader";

const StyledModal = Modal.styled`
  max-width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: ${(props) => props.opacity};
  transition : all 1s ease-in-out;
`;

function FixelLoaderModal({ show }) {
	const [isOpen, setIsOpen] = useState(show);
	const [opacity, setOpacity] = useState(0);

	useEffect(() => {
		setOpacity(0);
		setIsOpen(show);
	}, [show]);

	function afterOpen() {
		setTimeout(() => {
			setOpacity(1);
		}, 100);
	}

	function beforeClose() {
		return new Promise((resolve) => {
			setOpacity(0);
			setTimeout(resolve, 1000);
		});
	}

	return (
		<div>
			<StyledModal isOpen={isOpen} afterOpen={afterOpen} beforeClose={beforeClose} opacity={opacity} backgroundProps={{ opacity }}>
				<LottieLoader />
			</StyledModal>
		</div>
	);
}

export default memo(FixelLoaderModal);
